import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, KeepAlive as _KeepAlive, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "loading-div"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "loading-text"
}, "数据初始化中...", -1);
const _hoisted_3 = {
  class: "phone-frame"
};
const _hoisted_4 = ["src"];
import api from "@/api/shipin2/index.js";
import { store } from "../utils/store.js";
import { seriesLoadScripts, isMobile, getUrlParam } from '@/utils';
import { onMounted, ref, provide, watch } from "vue";
// import QrcodeVue from 'qrcode.vue';
import Fingerprint2 from 'fingerprintjs2'; // 引入fingerprintjs2
import { useRouter, useRoute } from "vue-router";
import { getAdsId, isWebClip } from '@/utils';
import { osName, osVersion, fullBrowserVersion, getUA } from 'mobile-device-detect';
import { ensureConfig } from '../utils/dataCache.js';

// 根据渠道码判断是否底部footer
// import { store } from '../utils/store.js';
import { channelCode } from '@/js/channel';
import { X } from '../utils/request';
export default {
  __name: 'index',
  setup(__props) {
    const hasqudao = store.filterQudaolist.includes(X.Xchanne || channelCode);
    const router = useRouter();
    const route = useRoute();
    const showInfo = ref(true);
    const pcIframeUrl = ref('');
    const mIframeWrap = ref(false);
    const loading = ref(true);
    provide('loading', loading);
    const queryWebsiteConfiguration = async () => {
      const cfg = await ensureConfig();
      document.title = cfg.logo_title;
      let $favicon = document.querySelector('link[rel="icon"]');
      if ($favicon && cfg.favicon_ico) $favicon.href = cfg.favicon_ico;
    };
    const showAd = ref(false);
    const getAllAd = async () => {
      // 5s后，这个loadding还显示 ，广告接口还没有加载好，刷新页页
      setTimeout(() => {
        if (loading.value) {
          console.log('loadding还没好，刷新网页');
          location.reload();
        }
      }, 5000);
      const res = await api.getAllAd();
      if (!res.data.filter(v => v.class_id == 15).length) {
        showAd.value = false;
        loading.value = false;
      } else {
        showAd.value = true;
        loading.value = false;
        // adList.value = res.data
        // sessionStorage.setItem('startAd', 1)
      }

      setTimeout(() => {
        store.setAdsList(res.data);
      }, 0);
      reportAds(store.adsIdConfig[route.path] + ',15', res.data);
    };

    // 统计代码
    const statistics = () => {
      let laId = 'KPTntdO13IY5KoXB';

      // 以下域名使用特定id
      if (['qqhj.shop', 'qqhj.org', 'qqhj.cc', 'abcd.cyou', '99hj.xyz', '99hj.vip'].includes(window.location.hostname)) {
        laId = 'KPXxhQ1xpOEiQCpj';
      }
      seriesLoadScripts({
        src: '//sdk.51.la/js-sdk-pro.min.js',
        id: 'LA_COLLECT',
        charset: 'UTF-8'
      }, () => {
        LA.init({
          id: laId,
          ck: laId
        });
      });
    };
    const buildPcIframeUrl = () => {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('pc_iframe', '1');
        // 确保内层不再触发外层包裹逻辑
        url.searchParams.delete('m_iframe');
        pcIframeUrl.value = url.toString();
      } catch (e) {
        // Fallback if URL constructor fails
        const hasQuery = window.location.href.includes('?');
        // 简单拼接，尽量剔除 m_iframe 参数
        const base = window.location.href.replace(/([?&])m_iframe=1(&|$)/, (m, p1, p2) => p1 === '?' && p2 ? '?' : '');
        pcIframeUrl.value = base + (base.includes('?') ? '&' : '?') + 'pc_iframe=1';
      }
    };
    const handlePage = () => {
      // 允许以下情况直接显示页面：
      // 1) 移动端
      // 2) pc_iframe=1 参数存在（用于 PC 包裹 iframe 时）
      // 3) 当前处于 iframe 内部（window.self !== window.top）
      const forcedInIframe = getUrlParam('pc_iframe') === '1';
      const inIframe = (() => {
        try {
          return window.self !== window.top;
        } catch (e) {
          return true;
        }
      })();
      const wantMobileWrap = getUrlParam('m_iframe') === '1';
      if (inIframe || forcedInIframe) {
        // 内层（iframe 内部）直接显示页面内容
        showInfo.value = false;
        document.documentElement.classList.add('pc-iframe-doc');
        mIframeWrap.value = false;
        return;
      }
      if (isMobile()) {
        if (wantMobileWrap) {
          // 移动端且显式要求包裹 iframe
          showInfo.value = true;
          document.documentElement.classList.remove('pc-iframe-doc');
          buildPcIframeUrl();
          mIframeWrap.value = true;
        } else {
          // 移动端默认不包裹
          showInfo.value = false;
          document.documentElement.classList.remove('pc-iframe-doc');
          mIframeWrap.value = false;
        }
      } else {
        // PC 顶层一律包裹 iframe
        showInfo.value = true;
        document.documentElement.classList.remove('pc-iframe-doc');
        buildPcIframeUrl();
        mIframeWrap.value = false;
      }
    };

    // 创建浏览器指纹
    const createFingerprint = () => {
      // 选择哪些信息作为浏览器指纹生成的依据
      const options = {
        fonts: {
          extendedJsFonts: true
        },
        excludes: {
          audio: true,
          userAgent: true,
          enumerateDevices: true,
          touchSupport: true
        }
      };
      // 浏览器指纹
      Fingerprint2.get(options, components => {
        // 参数只有回调函数或者options为{}时，默认浏览器指纹依据所有配置信息进行生成
        const values = components.map(component => component.value); // 配置的值的数组
        const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
        localStorage.setItem('browserId', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
        reportByFingerprint();
      });
    };
    const reportAds = async (ad_ids, data) => {
      await api.reportAds({
        ad_ids: getAdsId(ad_ids, data)
      });
    };
    const reportInstall = async () => {
      try {
        await api.reportInstall();
      } catch (error) {
        Promise.reject(error);
      }
    };
    const fetchReportIp = async stay_time => {
      try {
        let params = {
          phone_brand: osName,
          //手机品牌，识取取安卓或者ios
          phone_model: osName + osVersion,
          //手机型号 android15
          stay_time: stay_time ?? 0 //停留时间
        };

        await api.reportIp(params);
      } catch (error) {
        Promise.reject(error);
      }
    };

    // 汇报ip与循环，仅在实际渲染应用时启动（移动端或 iframe 内）
    let reportIpTimer = null;
    const startReportIpLoop = () => {
      if (reportIpTimer) return;
      fetchReportIp();
      reportIpTimer = setInterval(() => fetchReportIp(10), 1000 * 10);
    };
    const stopReportIpLoop = () => {
      if (reportIpTimer) {
        clearInterval(reportIpTimer);
        reportIpTimer = null;
      }
    };

    // 通过浏览器指纹上报的接口
    const reportByFingerprint = () => {
      getAllAd();
      if (isWebClip()) {
        reportInstall();
        queryWebsiteConfiguration({
          platform: "h5",
          imei: localStorage.getItem("browserId"),
          device: localStorage.getItem("browserId")
        });
      } else {
        queryWebsiteConfiguration();
      }
    };

    // 处理浏览器指纹
    const handleFingerprint = () => {
      if (localStorage.getItem('browserId')) {
        reportByFingerprint();
      } else {
        // 您不应在页面加载时或加载后直接运行指纹。 而是使用setTimeout或requestIdleCallback将其延迟几毫秒，以确保指纹一致。
        if (window.requestIdleCallback) {
          requestIdleCallback(() => {
            createFingerprint();
          });
        } else {
          setTimeout(() => {
            createFingerprint();
          }, 500);
        }
      }
    };
    onMounted(() => {
      // 先判断是否需要渲染应用主体还是仅展示 PC iframe 包裹层
      handlePage();
      if (!showInfo.value) {
        // 在实际渲染应用时才执行以下逻辑，避免 PC 外层与内层 iframe 双重请求
        handleFingerprint();
        startReportIpLoop();
        // statistics() // 如需统计可开启，但同样建议只在实际渲染应用时加载
      } else {
        stopReportIpLoop();
      }
      window.addEventListener('resize', () => {
        const prev = showInfo.value;
        handlePage();
        // 根据切换情况启动/停止循环上报，避免重复
        if (prev && !showInfo.value) {
          handleFingerprint();
          startReportIpLoop();
        }
        if (!prev && showInfo.value) {
          stopReportIpLoop();
        }
      });
    });
    return (_ctx, _cache) => {
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_van_overlay = _resolveComponent("van-overlay");
      const _component_AdsPictures = _resolveComponent("AdsPictures");
      const _component_RouterView = _resolveComponent("RouterView");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_van_overlay, {
        class: "loading-overlay",
        show: loading.value,
        "z-index": "9999"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_loading, {
          type: "spinner",
          color: "#ff9002"
        }), _hoisted_2])]),
        _: 1
      }, 8, ["show"]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_AdsPictures, {
        type: 15,
        random: true,
        number: 1,
        onClose: _cache[0] || (_cache[0] = $event => showAd.value = false),
        onImgLoad: _cache[1] || (_cache[1] = $event => loading.value = false)
      })], 512), [[_vShow, showAd.value]]), _withDirectives(_createElementVNode("div", null, [_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_component_RouterView, {
        key: 0
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [_createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: _ctx.$route.path
          }))])]),
          _: 2
        }, 1024)], 1024))]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [!_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_component_RouterView, {
          key: _ctx.$route.path
        })) : _createCommentVNode("", true)])]),
        _: 1
      }), !_unref(hasqudao) ? (_openBlock(), _createBlock(_component_Footer, {
        key: 1
      })) : _createCommentVNode("", true)], 512), [[_vShow, !showAd.value && !loading.value]])], 512), [[_vShow, !showInfo.value]]), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["pc-iframe-wrapper", {
          'm-iframe': mIframeWrap.value
        }])
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("iframe", {
        src: pcIframeUrl.value,
        frameborder: "0",
        class: "phone-iframe"
      }, null, 8, _hoisted_4)])], 2), [[_vShow, showInfo.value]])], 64);
    };
  }
};